import {Dispatch, SetStateAction} from "react";
import FiltersType from "@Pages/reviews/types/Filters.type";

export default function getArrayStateHandler(setFilters: Dispatch<SetStateAction<FiltersType>>) {
    const arrayStateHandler = (items, key) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            [key]: [...items],
        }))
    }

    return arrayStateHandler
}